module.exports = __webpack_public_path__ + "media/images/countryrect/iq-62312afd2d84c1a2e7922445ca35de9c.svg";